import { render, staticRenderFns } from "./NIM.vue?vue&type=template&id=ba71ff16&scoped=true"
import script from "./NIM.vue?vue&type=script&lang=js"
export * from "./NIM.vue?vue&type=script&lang=js"
import style0 from "./NIM.vue?vue&type=style&index=0&id=ba71ff16&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba71ff16",
  null
  
)

export default component.exports